import React from "react";
import { Link as MuiLink } from "@mui/material";
import { DataCardShell } from "../../../../../components/responsive";
import Helpers from "../../../../../components/Helpers";
import MasterRowActions from "../../../../../components/masterData/MasterRowActions";
import { parishAddressLine } from "../parishDisplay";

export function ParishCard({
  row,
  isAdmin,
  onEdit,
  onDelete,
  onOpenRetreats,
  onOpenCouples,
}: {
  row: any;
  isAdmin: boolean;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
  onOpenRetreats: (row: any) => void;
  onOpenCouples: (row: any) => void;
}) {
  const title =
    row.link && row.link !== "" ? (
      <MuiLink
        href={row.link}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: "#1265c4", fontWeight: 800, textDecoration: "underline" }}
      >
        {row.parish || "Untitled parish"}
      </MuiLink>
    ) : (
      row.parish || "Untitled parish"
    );

  return (
    <DataCardShell
      title={title}
      subtitle={[
        row.uniqueId ? `Parish ID ${row.uniqueId}` : null,
        row.parishCategoryName || null,
        row.deaneryName || null,
      ]
        .filter(Boolean)
        .join(" · ")}
      fields={[
        { label: "Spanish Parish", value: row.spanishParish || "—" },
        { label: "Address", value: parishAddressLine(row) || "—" },
        {
          label: "Retreats",
          value: (
            <MuiLink
              component="button"
              type="button"
              onClick={() => onOpenRetreats(row)}
              sx={{ cursor: "pointer" }}
            >
              {row.Retreats_count ?? 0}
            </MuiLink>
          ),
        },
        {
          label: "Couples",
          value: (
            <MuiLink
              component="button"
              type="button"
              onClick={() => onOpenCouples(row)}
              sx={{ cursor: "pointer" }}
            >
              {row.couples_count ?? 0}
            </MuiLink>
          ),
        },
        {
          label: "Created",
          value: row.createdAt
            ? Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY")
            : "—",
        },
      ]}
      primaryAction={
        isAdmin ? (
          <MasterRowActions
            onEdit={() => onEdit(row)}
            onDelete={() => onDelete(row)}
          />
        ) : undefined
      }
    />
  );
}
